import { v4 as uuid } from 'uuid';
import { DialogBranch } from '@storyverseco/svs-dialog-ruleset';
import { DialogLike } from '../types';

/**
 * This migration got introduced because steps were a linear array. With the choices feature
 * we introduce the navigation object.
 */

export const migrateStepNavigation = async (dialog: DialogLike): Promise<DialogLike> => {
  const steps = (dialog.scenes.scene1.branches.start as DialogBranch).steps;

  const ids = steps.map((_s) => uuid());

  const newSteps = steps.map((step, index) => {
    const id = ids[index];
    return {
      ...step,
      navigation: {
        id,
        previous: ids[index - 1],
        next: ids[index + 1],
      },
    };
  });

  return {
    ...dialog,
    scenes: {
      ...dialog.scenes,
      scene1: {
        ...dialog.scenes.scene1,
        branches: {
          ...dialog.scenes.scene1.branches,
          start: {
            ...(dialog.scenes.scene1.branches.start as DialogBranch),
            initialStep: ids[0],
            steps: newSteps,
          },
        },
      },
    },
  };
};
